/*
  Mobile exit intent for the "$20 off / You found your people" signup popup
  (Shopify Forms "Subscribe Overlay", form id 827229).

  Shopify Forms only detects exit intent on desktop (document "mouseleave" with
  clientY <= 150). On that event its own handler sets
  window.ShopifyForms.triggerExitIntent, mounts the form and opens it. Phones never
  fire mouseleave, so this script watches for mobile exit signals and dispatches
  that same event. The popup stays Shopify's own (same styling, copy, offer and
  signup); no markup is added here.

  Needs the form's device filter set to "all" in the Forms admin, otherwise the
  app is never mounted on a phone and the event is ignored (fails closed).

  Signals (after real engagement):
    - reaching the bottom of the page (footer in view, or ~95% scrolled)
    - fast upward scroll toward the top
    - returning to the tab/app after being away (visibilitychange)
  Gates: phone-sized touch screens only, never in the first 15s of the session,
  once per session, not while the variant picker / cart drawer / menu / a text
  field is in use, not while the cookie bar or another dialog is up, not for
  subscribers. Dismissal memory is Forms' own.

  QA: add ?exitdebug=1 to skip the time, engagement, once-per-session and
  subscriber gates (Forms' own dismissal memory still applies).
*/
(function () {
  if (window.__cxcMobileExitBound) return;
  window.__cxcMobileExitBound = true;

  var MIN_SESSION_MS = 15000;
  var ENGAGED_MS = 20000;
  var ENGAGED_DEPTH = 0.4;
  var BOTTOM_DEPTH = 0.95;
  var FLICK_WINDOW_MS = 350;
  var FLICK_MIN_PX_PER_MS = 1.4;
  var FLICK_MIN_VIEWPORTS = 0.5;
  var AWAY_MIN_MS = 3000;
  var PICKER_QUIET_MS = 10000;
  var TOUCH_QUIET_MS = 1500;
  var FORM_ID = '1214484'; // Joi Oct 31: mobile exit shows the 20% form only; the popup-open gate watches it

  var debug = /[?&]exitdebug=1/.test(location.search);

  function store(kind, key, value) {
    try {
      var s = window[kind];
      if (value === undefined) return s.getItem(key);
      s.setItem(key, value);
    } catch (e) {}
    return null;
  }

  function isPhone() {
    return (
      window.matchMedia('(pointer: coarse)').matches &&
      Math.min(window.innerWidth, window.innerHeight) <= 749
    );
  }
  if (!isPhone()) return;
  // ?exitdebug=1 also bypasses the subscriber suppression, so a logged-in
  // subscriber (or anyone who already submitted) can still see it in QA.
  var suppressed = !!window.cxcExitSuppress || store('localStorage', 'cxc_subscribed') === '1';
  if (suppressed && !debug) return;

  var now = Date.now;
  var sessionStart = Number(store('sessionStorage', 'cxc_session_start'));
  if (!sessionStart) {
    sessionStart = now();
    store('sessionStorage', 'cxc_session_start', String(sessionStart));
  }
  var pageStart = now();
  var peakY = 0;
  var lastTouchAt = 0;
  var touching = false;
  var lastPickerAt = 0;
  var hiddenAt = 0;
  var samples = [];

  function maxScroll() {
    return Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  }

  function engaged() {
    if (debug) return true;
    return now() - pageStart >= ENGAGED_MS || peakY / maxScroll() >= ENGAGED_DEPTH;
  }

  function alreadyFired() {
    return !debug && store('sessionStorage', 'cxc_exit_fired') === '1';
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.width > 0 && r.height > 0;
  }

  // Returns why the shopper is busy, or '' when it is safe to show the popup.
  function busyReason() {
    var body = document.body;
    if (!body) return 'no-body';
    if (touching || now() - lastTouchAt < TOUCH_QUIET_MS) return 'touch';
    if (now() - lastPickerAt < PICKER_QUIET_MS) return 'picker-used';
    var selects = document.querySelector('variant-selects');
    if (selects && visible(selects)) return 'picker-visible';
    if (document.querySelector('cart-drawer.active, cart-drawer[open]')) return 'cart-drawer';
    if (body.classList.contains('overflow-hidden') || /overflow-hidden-/.test(body.className)) return 'drawer-or-menu';
    if (document.querySelector('details[open] > summary.header__icon--search, details-modal[open], .search-modal[open]')) return 'search';
    var ae = document.activeElement;
    // a tapped variant radio/checkbox keeps focus; only real text entry counts as typing
    if (ae && (ae.isContentEditable || ae.tagName === 'TEXTAREA' || ae.tagName === 'SELECT' ||
        (ae.tagName === 'INPUT' && !/^(radio|checkbox|button|submit|reset|image|range|color|file)$/i.test(ae.type)))) {
      return 'typing';
    }
    var cookie = document.getElementById('cxc-cookie-consent');
    if (cookie && visible(cookie) && getComputedStyle(cookie).display !== 'none') return 'cookie-bar';
    var host = document.getElementById('app-embed-container-' + FORM_ID);
    if (host && host.shadowRoot && host.shadowRoot.querySelector('#app-embed[data-current-step="form"]')) return 'popup-open';
    return '';
  }

  function eligible() {
    if (document.visibilityState !== 'visible') return false;
    if (alreadyFired()) return false;
    if (!debug && now() - sessionStart < MIN_SESSION_MS) return false;
    if (!engaged()) return false;
    return !busyReason();
  }

  function fire(reason) {
    if (!eligible()) return false;
    store('sessionStorage', 'cxc_exit_fired', '1');
    (window.dataLayer = window.dataLayer || []).push({ event: 'mobile_exit_intent', exit_reason: reason });
    if (typeof window.gtag === 'function') window.gtag('event', 'mobile_exit_intent', { exit_reason: reason });
    // Same event Forms' own desktop detector listens for.
    document.dispatchEvent(new MouseEvent('mouseleave', { clientY: 0 }));
    return true;
  }

  /* picker / touch activity: never compete with the shopper's hands */
  function markPicker(e) {
    if (e.target.closest && e.target.closest('variant-selects, product-form, .product-form')) lastPickerAt = now();
  }
  document.addEventListener('pointerdown', markPicker, true);
  document.addEventListener('change', markPicker, true);
  document.addEventListener('focusin', markPicker, true);
  document.addEventListener('touchstart', function () { touching = true; lastTouchAt = now(); }, { passive: true, capture: true });
  ['touchend', 'touchcancel'].forEach(function (t) {
    document.addEventListener(t, function () { touching = false; lastTouchAt = now(); }, { passive: true, capture: true });
  });

  /* signal 1: fast upward scroll toward the top */
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var t = now();
    if (y > peakY) peakY = y;
    samples.push({ y: y, t: t });
    while (samples.length && t - samples[0].t > FLICK_WINDOW_MS) samples.shift();
    if (samples.length < 2) return;
    var first = samples[0];
    var up = first.y - y;
    var dt = Math.max(1, t - first.t);
    if (up < window.innerHeight * FLICK_MIN_VIEWPORTS || up / dt < FLICK_MIN_PX_PER_MS) return;
    // heading for the top of the page: ended in the top 40% of where they had been
    if (y > peakY * 0.4 && y > window.innerHeight) return;
    // the scroll itself is a touch gesture, so give it a moment to settle
    setTimeout(function () { fire('scroll_up'); }, TOUCH_QUIET_MS + 100);
  }, { passive: true });

  /* signal 3: reached the bottom of the page (footer in view or ~95% scrolled).
     Only on pages long enough to scroll, and only once the shopper has actually
     scrolled; the touch has to settle first so the popup never lands mid-swipe. */
  var bottomTimer = 0;
  function atBottom() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var max = maxScroll();
    if (y <= 0 || max < window.innerHeight * 1.5) return false;
    if (y / max >= BOTTOM_DEPTH) return true;
    // the footer group is several sections; its first one coming into view means they are at the end
    var footer = document.querySelector('.shopify-section-group-footer-group, #shopify-section-footer, footer');
    if (!footer) return false;
    return footer.getBoundingClientRect().top <= window.innerHeight * 0.85;
  }
  window.addEventListener('scroll', function () {
    if (bottomTimer || alreadyFired()) return;
    var tries = 0;
    function check() {
      bottomTimer = 0;
      if (alreadyFired() || !atBottom()) return;
      if (fire('bottom')) return;
      // gated (too early, picker just used, touch not settled): they are still
      // parked at the bottom, so look again shortly instead of waiting for a scroll
      if (++tries <= 8) bottomTimer = setTimeout(check, 1500);
    }
    bottomTimer = setTimeout(check, TOUCH_QUIET_MS + 200);
  }, { passive: true });

  /* signal 2: left the tab/app and came back */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      hiddenAt = now();
      return;
    }
    if (hiddenAt && now() - hiddenAt >= AWAY_MIN_MS) {
      hiddenAt = 0;
      setTimeout(function () { fire('return'); }, 800);
    }
  });

  window.cxcMobileExit = {
    fire: function () { return fire('manual'); },
    why: function () { return busyReason() || (eligible() ? 'eligible' : 'gated'); },
    debug: debug
  };
})();
